// extracted by mini-css-extract-plugin
export default {"root":"ClientsGridRoute_root__AHWAA"};